/* global debounce */

/* Next Item to Build 
- Able to handle adding more than the balance at the first time one shot
- Found the page for the error message and quantity selector updator already
*/

if (!customElements.get("product-form")) {
	class ProductForm extends HTMLElement {
		constructor() {
			super();
			if (this.hasChildNodes()) this.init();
		}

		init() {
			this.productHandle = this.dataset.productHandle;
			if (!this.productHandle) {
				console.warn("Missing product handle in <product-form>:", this);
				return;
			}
			// console.log("Product handle v2:", this.productHandle);

			this.form = this.querySelector(".js-product-form");
			if (this.form) {
				this.form.querySelector('[name="id"]').disabled = false;
				this.cartDrawer = document.querySelector("cart-drawer");
				this.submitBtn = this.querySelector('[name="add"]');
				this.form.addEventListener(
					"submit",
					this.handleSubmit.bind(this)
				);

				if (this.dataset.showQuantitySelector) {
					this.quantitySelector =
						this.querySelector("quantity-input");

					if (this.quantitySelector) {
						this.quantityInput =
							this.quantitySelector.querySelector(
								".qty-input__input"
							);
						this.quantitySelector.addEventListener(
							"change",
							debounce(this.handleChange.bind(this))
						);
						this.lineItemChangeListener =
							this.lineItemChangeListener ||
							this.handleLineItemChange.bind(this);
						document.addEventListener(
							"on:line-item:change",
							(evt) => {
								this.lineItemChangeListener(evt);
							}
						);
					}
				}

				this.setMaximumInputQuantity();
				this.handleQuantityButtonState();
				document.addEventListener(
					"on:variant:change",
					this.setMaximumInputQuantity.bind(this)
				);
			}
		}

		disconnectedCallback() {
			document.removeEventListener(
				"on:line-item:change",
				this.lineItemChangeListener
			);
		}

		/**
		 * Sets the max attribute of the quantity input
		 */
		setMaximumInputQuantity() {
			const productInfo =
				this.closest(".product-info") ||
				this.closest("quick-add-drawer");
			if (productInfo) {
				const quantitySelector = this.querySelector("quantity-input");
				if (quantitySelector) {
					const quantityInput =
						quantitySelector.querySelector(".qty-input__input");
					const dataEl =
						productInfo.querySelector(".js-inventory-data");
					if (dataEl) {
						const variantId = Number(
							this.form.querySelector('[name="id"]').value
						);
						const inventoryJson = JSON.parse(dataEl.textContent);
						const inventory = inventoryJson.find(
							(item) => item.id === variantId
						);

						if (
							inventory.inventory_management.length !== 0 &&
							inventory.inventory_quantity > 0 &&
							inventory.inventory_policy !== "continue"
						) {
							quantityInput.max = inventory.inventory_quantity;

							const currentQuantity = Number(quantityInput.value);
							if (
								currentQuantity > 1 &&
								currentQuantity > inventory.inventory_quantity
							) {
								quantityInput.value = quantityInput.max;
								quantityInput.value = currentQuantity; // EF edit
							}
						}
					}

					const minusButton =
						quantitySelector.querySelector(".btn--minus");
					const plusButton =
						quantitySelector.querySelector(".btn--plus");
					ProductForm.setQuantityButtonState(
						null,
						quantityInput,
						minusButton,
						plusButton
					);
				}
			}
		}

		/**
		 * Sets the max attribute of the quantity input
		 */
		handleQuantityButtonState() {
			const productInfo =
				this.closest(".product-info") ||
				this.closest("quick-add-drawer");
			if (productInfo) {
				const quantitySelector = this.querySelector("quantity-input");
				if (quantitySelector) {
					const quantityInput =
						quantitySelector.querySelector(".qty-input__input");
					const minusButton =
						quantitySelector.querySelector(".btn--minus");
					const plusButton =
						quantitySelector.querySelector(".btn--plus");

					plusButton.addEventListener("click", () => {
						ProductForm.setQuantityButtonState(
							"up",
							quantityInput,
							minusButton,
							plusButton
						);
					});

					minusButton.addEventListener("click", () => {
						ProductForm.setQuantityButtonState(
							"down",
							quantityInput,
							minusButton,
							plusButton
						);
					});

					ProductForm.setQuantityButtonState(
						null,
						quantityInput,
						minusButton,
						plusButton
					);
				}
			}
		}

		static setQuantityButtonState(
			direction,
			quantityInput,
			minusButton,
			plusButton
		) {
			const currentQuantity = Number(quantityInput.value);
			const max = Number(quantityInput.max);
			const min = Number(quantityInput.min);

			let newQuantity = currentQuantity;

			if (direction === "up") {
				newQuantity = currentQuantity + 1;
			} else if (direction === "down") {
				newQuantity = currentQuantity - 1;
			}

			// Enable or disable buttons based on the newQuantity relative to max and min
			minusButton.disabled = newQuantity <= min;
			plusButton.disabled = max > 0 && newQuantity >= max;
		}

		/**
		 * Handles 'change' events on the line item (dispatched by the theme).
		 * @param {object} evt - Event object.
		 */
		handleLineItemChange(evt) {
			if (evt.detail.variantId.toString() === this.dataset.variantId) {
				debounce(this.updateQuantityState(evt.detail.newQuantity));
			}
		}

		/**
		 * Handles 'change' events on the quantity-input element.
		 * @param {object} evt - Event object.
		 */
		handleChange(evt) {
			console.log("QUANTITY INPUT CHANGE:", evt.target.value);
			this.updateQuantity(evt.target.value);
		}

		/**
		 * Handles submission of the product form.
		 * @param {object} evt - Event object.
		 */
		async handleSubmit(evt) {
    if (evt.target.id === "product-signup_form") return;

    evt.preventDefault();

    if (this.submitBtn.getAttribute("aria-disabled") === "true") return;

    if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
    }

    this.errorMsg = null;
    this.setErrorMsgState();

    // Disable "Add to Cart" button until submission is complete.
    this.submitBtn.setAttribute("aria-disabled", "true");
    this.submitBtn.classList.add("is-loading");

    // Build formData trước
    const formData = new FormData(this.form);

    // [FIX] Clamp quantity theo step/max, override thẳng vào formData
    const qtyInputEl = this.form.querySelector('input[name="quantity"]');
    if (qtyInputEl) {
        const step    = Number(qtyInputEl.step) || 1;
        const min     = Number(qtyInputEl.min)  || 0;
        const max     = Number(qtyInputEl.max);
        const current = Number(qtyInputEl.value);

        console.log(`[ATC] step=${step}, min=${min}, max=${max}, current=${current}`);

        if (max && current > max) {
            const clamped     = Math.floor((max - min) / step) * step + min;
            const safeClamped = Math.max(clamped, min);
            console.log(`[ATC Clamp] ${current} → ${safeClamped}`);
            formData.set('quantity', safeClamped); // override formData trực tiếp
            qtyInputEl.value = safeClamped;        // sync lại DOM cho nhất quán
        }
    }

    const variantId = formData.get("id");
    const productId = formData.get("product-id");
    const pQuantity = Number(formData.get('quantity'));
    console.log("[ATC] Final quantity submitted:", pQuantity);

    let sections = "cart-icon-bubble";
    if (this.cartDrawer) {
        sections += `,${this.cartDrawer
            .closest(".shopify-section")
            .id.replace("shopify-section-", "")}`;
    }

    console.log("product add form submission handle submit");

    // Get all quick order lists on the page
    const quickOrderSections = [];
    document.querySelectorAll("quick-order-list").forEach((quickOrderList) => {
        const closestSection = quickOrderList.closest(".shopify-section");
        if (closestSection) {
            const sectionId = closestSection.id.replace("shopify-section-", "");
            sections += `,${sectionId}`;
        }
    });

    formData.append("sections_url", window.location.pathname);
    formData.append("sections", sections);

    const fetchRequestOpts = {
        method: "POST",
        headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
    };

    try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        console.log("RESPONSE DATA:", data);

        if (
            (data.message && data.message.includes("maximum quantity")) ||
            (data.message && data.message.includes("due to availability"))
        ) {
            const qtyAdded  = data.message.match(/\d+/)?.[0] || 0;
            const balanceQty = pQuantity - qtyAdded;
            console.log('balance Qty', balanceQty);
            if (await variantConditionsChecker(variantId)) {
                console.log("Try adding the balance quantity to the next variant");
                addNextVariant(variantId, this.productHandle, balanceQty);
            }
        } else {
            let error = typeof data.description === "string"
                ? data.description
                : data.message;
            if (data.errors && typeof data.errors === "object") {
                error = Object.entries(data.errors).map((item) => item[1].join(", "));
            }

            if (data.status) this.setErrorMsgState(error);

            if (!response.ok) throw new Error(response.status);
        }

        if (theme.settings.afterAtc === "page") {
            setTimeout(() => {
                window.location.href = theme.routes.cart;
            }, 300);
        } else {
            ProductForm.updateCartIcon(data);

            const quickAddDrawer = this.closest("quick-add-drawer");
            if (quickAddDrawer) quickAddDrawer.addedToCart();

            setTimeout(() => {
                if (this.cartDrawer) {
                    this.cartDrawer.renderContents(
                        data,
                        !quickAddDrawer &&
                        ((theme.settings.afterAtc === "drawer_desktop" && theme.mediaMatches.md) ||
                            theme.settings.afterAtc === "drawer")
                    );

                    if (quickOrderSections.length) {
                        quickOrderSections.forEach((quickOrderSection) => {
                            const sectionEl = document.getElementById(quickOrderSection.id);
                            if (!sectionEl) return;
                            const el = sectionEl.querySelector(quickOrderSection.selector) || sectionEl;
                            el.innerHTML = ProductForm.getElementHTML(
                                data.sections[quickOrderSection.section],
                                quickOrderSection.selector
                            );
                        });
                    }
                } else if (window.location.pathname === theme.routes.cart) {
                    const cartItems = document.querySelector("cart-items");
                    if (cartItems) {
                        if (cartItems.dataset.empty === "true") {
                            window.location.reload();
                        } else {
                            cartItems.refreshCartItems();
                        }
                    }
                }
            }, 700);

            document.dispatchEvent(
                new CustomEvent("dispatch:cart-drawer:refresh", { bubbles: true })
            );
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
            (item) => item.variant_id === data.variant_id
        )[0];

        let newQuantity = 1;
        console.log("ADDING CUSTOM PRODUCT TO CART");

        if (itemInOldCart) {
            newQuantity = itemInOldCart.quantity === data.quantity
                ? itemInOldCart.quantity
                : data.quantity;
            this.dispatchEvent(
                new CustomEvent("on:line-item:change", {
                    bubbles: true,
                    detail: {
                        cart: newCartData,
                        variantId: data.variant_id,
                        oldQuantity: itemInOldCart.quantity,
                        newQuantity,
                    },
                })
            );
        } else {
            this.dispatchEvent(
                new CustomEvent("on:cart:add", {
                    bubbles: true,
                    detail: {
                        cart: newCartData,
                        variantId: data.variant_id,
                    },
                })
            );

            if (this.quantitySelector) {
                this.setAttribute("data-show-quantity-selector", "true");
                this.quantityInput.value = newQuantity;
                this.quantitySelector.currentQty = this.quantityInput.dataset.initialValue;
            }
        }
    } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(
            new CustomEvent("on:cart:error", {
                bubbles: true,
                detail: { error: this.errorMsg.textContent },
            })
        );

        if (this.cartDrawer) this.cartDrawer.refreshCartDrawer();
    } finally {
        this.submitBtn.classList.add("is-success");
        this.submitBtn.removeAttribute("aria-disabled");
        setTimeout(() => {
            this.submitBtn.classList.remove("is-loading");
            this.submitBtn.classList.remove("is-success");
        }, 1400);
    }
}

		/**
		 * Updates the cart icon count in the header.
		 * @param {object} response - Response JSON.
		 */
		static updateCartIcon(response) {
			const cartIconBubble = document.getElementById("cart-icon-bubble");
			if (cartIconBubble) {
				cartIconBubble.innerHTML =
					response.sections["cart-icon-bubble"];
			}
		}

		updateQuantityState(newQuantity) {
			this.quantityInput.value = newQuantity;
			this.quantitySelector.currentQty = newQuantity;
			this.setAttribute(
				"data-show-quantity-selector",
				newQuantity > 0 ? "true" : "false"
			);
		}

		async updateQuantity(quantity) {
			this.quantitySelector.setAttribute("aria-disabled", "true");
			const lineErrors = this.querySelector(".js-product-form-errors");

			const fetchRequestOpts = {
				method: "POST",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
			};

			// I think this is to add quantity to the cart and check if got errors (EF edit)
			fetchRequestOpts.body = JSON.stringify({
				id: this.dataset.variantId,
				quantity,
			});

			try {
				const response = await fetch(
					theme.routes.cartChange,
					fetchRequestOpts
				);
				const data = await response.json();

				if (!response.ok)
					throw new Error(data.errors || response.status); // show error message for exceeding max quantity - EF Notes

				lineErrors.innerHTML = "";
				lineErrors.hidden = true;
			} catch (error) {
				if (/^[0-9]+$/.test(error.message)) {
					lineErrors.textContent = theme.strings.cartError;
				} else {
					lineErrors.textContent = error.message;
				}
				lineErrors.hidden = false;
				console.log(error); // eslint-disable-line

				const oldQuantity = parseInt(
					this.quantityInput.dataset.initialValue,
					10
				);
				this.updateQuantityState(oldQuantity);
			} finally {
				this.updateQuantityState(parseInt(quantity, 10));
				this.quantitySelector.removeAttribute("aria-disabled");
				if (this.cartDrawer) this.cartDrawer.refreshCartDrawer();
			}
		}

		/**
		 * Gets the innerHTML of an element.
		 * @param {string} html - Section HTML.
		 * @param {string} selector - CSS selector for the element to get the innerHTML of.
		 * @returns {string}
		 */
		static getElementHTML(html, selector) {
			const tmpl = document.createElement("template");
			tmpl.innerHTML = html;

			const el = tmpl.content.querySelector(selector);
			return el ? el.innerHTML : "";
		}

		/**
		 * Shows/hides an error message.
		 * @param {string} [error=false] - Error to show a message for.
		 */
		setErrorMsgState(error = false) {
			this.errorMsg =
				this.errorMsg || this.querySelector(".js-form-error");
			if (!this.errorMsg) return;

			this.errorMsg.hidden = !error;
			if (error) {
				this.errorMsg.innerHTML = "";
				const errorArray = Array.isArray(error) ? error : [error];
				errorArray.forEach((err, index) => {
					if (index > 0)
						this.errorMsg.insertAdjacentHTML("beforeend", "<br>");
					this.errorMsg.insertAdjacentText("beforeend", err);
				});
			}
		}
	}

	customElements.define("product-form", ProductForm);
}

addNextVariant = async (variantId, productHandle, quantity = 1) => {
	// Fetch the variant details
	// const nextVariant = "44605733535952";
	const nextQuantity = quantity;

	const nextVariant = await findNextVariant(variantId, productHandle);

	console.log(
		`Adding next variant ${nextVariant} with quantity ${nextQuantity} to cart`
	);

	const formData = new FormData();
	formData.append("id", nextVariant);
	formData.append("quantity", nextQuantity);
	formData.append("sections_url", window.location.pathname);

	// You may reuse section list logic from handleSubmit if needed
	let sections = "cart-icon-bubble";
	const cartDrawerEl = document.querySelector("cart-drawer");
	if (cartDrawerEl) {
		const cartDrawerSection = cartDrawerEl.closest(".shopify-section");
		if (cartDrawerSection) {
			sections += `,${cartDrawerSection.id.replace(
				"shopify-section-",
				""
			)}`;
		}
	}
	formData.append("sections", sections);

	try {
		const response = await fetch(theme.routes.cartAdd, {
			method: "POST",
			headers: {
				Accept: "application/javascript",
				"X-Requested-With": "XMLHttpRequest",
			},
			body: formData,
		});

		const data = await response.json();
		console.log("NEXT VARIANT ADDED:", data);

		if (response.ok) {
			// Optionally dispatch event to update cart UI
			const newCartResponse = await fetch(`${theme.routes.cart}.js`);
			const newCartData = await newCartResponse.json();

			document.dispatchEvent(
				new CustomEvent("on:cart:add", {
					bubbles: true,
					detail: {
						cart: newCartData,
						variantId: nextVariant,
					},
				})
			);

			// Update the cart icon count.

			// Attempt 1
			// ProductForm.updateCartIcon(newCartData);

			// Attempt 2
			document.dispatchEvent(
				new CustomEvent("dispatch:cart-drawer:refresh", {
					bubbles: true,
				})
			);
		} else {
			console.warn("Failed to add next variant:", data);
		}
	} catch (error) {
		console.error("Error adding next variant:", error);
	}
};

variantConditionsChecker = async (variantId, temperature = null) => {
	// check if current variant is under near expiry
	console.log("variant id:", variantId);

	const response = await fetch(`/variants/${variantId}.js`);
	const variant = await response.json();
	console.log("VARIANT INFO:", variant);

	const expiryDate = new Date(variant.title);

	// check if expiry date is less than 30 days from now
	const currentDate = new Date();
	const daysUntilExpiry = Math.ceil(
		(expiryDate - currentDate) / (1000 * 60 * 60 * 24)
	);
	// if (temperature == null) {
	// 	if (daysUntilExpiry <= 30) {
	// 		console.log("Variant is near expiry:", variant.title);
	// 		return false; // Variant is near expiry
	// 	}
	// } else {
	// 	if (daysUntilExpiry <= 7) {
	// 		console.log("Variant is near expiry:", variant.title);
	// 		return false; // Variant is near expiry
	// 	}
	// }
	console.log("Variant is normal:", variant.title);
	return true;
};

findNextVariant = async (currVariantId, productHandle) => {
	const response = await fetch(`/products/${productHandle}.js`);
	const product = await response.json();

	console.log("PRODUCT INFO:", product);

	const variants = product.variants;
	const sortedVariants = product.variants.slice().sort((a, b) => {
		const dateA = new Date(a.title);
		const dateB = new Date(b.title);
		return dateA - dateB;
	});

	console.log("VARIANTS:", variants);
	console.log("SORTED VARIANTS:", sortedVariants);
	console.log("CURRENT VARIANT ID:", currVariantId);

	const currentIndex = sortedVariants.findIndex((v) => v.id == currVariantId);

	if (currentIndex === -1) {
		console.warn("Current variant not found");
		return null;
	}

	console.log("Current variant index:", currentIndex);

	// Check if current variant is under expiry plan
	const currentVariantTitle = sortedVariants[currentIndex].title;
	const isCurrentVariantNormal = await variantConditionsChecker(
		currVariantId
	);
	console.log(
		currentVariantTitle,
		"Is current variant normal?",
		isCurrentVariantNormal
	);

	// Check if there's a next variant, only if normal (not expiry) product
	if (currentIndex + 1 < variants.length && isCurrentVariantNormal) {
		const nextVariant = sortedVariants[currentIndex + 1];
		console.log("Next variant:", nextVariant);
		return nextVariant.id;
	} else {
		console.log("No next variant found");
		return null;
	}
};
